import customFetch from '../utils/fetch';
import { API_ENDPOINTS } from '../constants/api-endpoint';

const saveConfidentialityAgreement = async (data) => {
  try {
    return await customFetch(API_ENDPOINTS.CONFIDENTIALITY_AGREEMENT_SAVE, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json'
      }
    });
  } catch (error) {
    console.error('機密保持誓約保存エラー:', error);
    throw error;
  }
};

export const confidentialityService = {
  saveConfidentialityAgreement
};
